export default {
  // 數據統計
  totalData: "共計{count}條數據",

  // 加載
  loading: "拼命加載中",

  // 表格列
  address: "地址",
  balance: "餘額",
  operation: "操作",

  // 操作
  viewDetails: "查看詳情",

  // 空狀態
  noData: "暫無數據",

  // 下載
  downloadDetails: "下載數據明細",
  downloadFileName: "數據明細",

  // 消息提示
  copySuccess: "複製成功",
};
